var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCappingChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,67.7c-2.5-3.4-4.1-7.5-4.1-12,0-11.1,9-20.1,20.1-20.1s2.9-1.3,2.9-2.9V15.6c0-1.6-1.3-2.9-2.9-2.9C20.5,12.7,1,32,1,55.7s4.2,20.7,10.9,28.3l16.3-16.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.3,99c23.7,0,43-19.5,43-43.2s-1.3-2.9-2.9-2.9h-17.2c-1.6,0-2.9,1.3-2.9,2.9,0,11.1-9,20.1-20.1,20.1s-8.6-1.5-12-4.1l-16.3,16.3c7.6,6.6,17.5,10.9,28.3,10.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.9,55.7c0,7.9,6.4,14.3,14.3,14.3s14.3-6.4,14.3-14.3-6.4-14.3-14.3-14.3-14.3,6.4-14.3,14.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.2,3.9c0-1.6-1.3-2.9-2.9-2.9h-3.8c-1.6,0-2.9,1.3-2.9,2.9v37.5h9.6V3.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.1,24.2h-6.9v17.2h6.9c1.6,0,2.9-1.3,2.9-2.9v-11.5c0-1.6-1.3-2.9-2.9-2.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.9,41.4h9.6V15.6c0-1.6-1.3-2.9-2.9-2.9h-6.7v28.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCappingChart);
export default __webpack_public_path__ + "static/media/capping-chart.23d5ef105ae16d47310eae3f4ffa9958.svg";
export { ForwardRef as ReactComponent };